// React things
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { version } from "../../../../package.json";

// Styles
import style from "./Profile.module.css";

// Components
import LeaderSection from "../../Components/ProfileSections/LeaderSection.jsx";

import VoucherSection from "../../Components/ProfileSections/VoucherSection.jsx";
import AchivementSection from "../../Components/ProfileSections/AchivementSection.jsx";

import LoadingWrapper from "../../ComponentsWrappers/LoadingWrapper.jsx";

// Stores
import useSourceStore from "../../Store/SourceStore.js";
import useApplicationSettings from "../../Store/ApplicationSettings.js";

// Downloads files

import ContentSection from "../../Components/ProfileSections/ContentSection.tsx";
import { useTelegramWebApp } from "../../Telegram/WebAppProvider";

const Profile = () => {
  const [localizationKey, setLocalizationKey] = useState(0);
  const [userData, setUserData] = useState(null);

  const navigate = useNavigate();
  const { initData, isInitialized } = useTelegramWebApp();

  // SourceStore Setters
  const headerNight = useSourceStore((state) => state.headerNight);

  // ApplicationSettings
  const setShowMenubar = useApplicationSettings(
    (state) => state.setShowMenubar
  );
  const setBackButton = useApplicationSettings((state) => state.setBackButton);
  const localization = useApplicationSettings((state) => state.localization);

  const tg = window.Telegram.WebApp;

  useEffect(() => {
    setShowMenubar(true);
    if (initData?.user?.id) {
      setUserData(initData.user);
    }
  }, [initData, setShowMenubar]);

  useEffect(() => {
    setLocalizationKey((prev) => prev + 1);
  }, [localization]);

  function setSection() {
    return (
      <>
        <div
          onClick={() => {
            navigate("/leaderboard");
          }}
          className={style["section"]}
        >
          <LoadingWrapper key={localizationKey}>
            <LeaderSection />
          </LoadingWrapper>
        </div>
        {/* <div onClick={()=>{
                    navigate('/history')
                    // vibrateDevice()
                }} className={style['section']}>
                    <LoadingWrapper key={localizationKey}>
                        <HistorySection/>
                    </LoadingWrapper>
                </div> */}
        <div
          onClick={() => {
            navigate("/vouchers");
          }}
          className={style["section"]}
        >
          <LoadingWrapper key={localizationKey}>
            <VoucherSection />
          </LoadingWrapper>
        </div>
        <div className={style["section"]}>
          <ContentSection />
        </div>
        <div className={style["section"]}>
          <AchivementSection />
        </div>

        {/* <div className={style['section']}>
                    <ExchangeSection/>
                </div> */}
      </>
    );
  }
  return (
    <div className={style["container"]}>
      <div className={style["version"]}>v{version}</div>
      <div className={style["header"]}>
        <img className={style["profile-background"]} src={headerNight} />
        <img
          className={style["avatar"]}
          src={tg.initDataUnsafe.user.photo_url}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "placeholder_avatar.png";
          }}
        />
        {/* <img className={style['avatar']} src={`https://dreamcoin.pro/images/users/${tg.WebAppUser.user?.id}.jpg`}/> */}

        <div className={style["user-info"]}>
          <div className={style["username"]}>
            {userData?.first_name
              ? `${userData.first_name} ${userData.last_name ?? ""}`
              : "Name"}
          </div>
          <div className={style["nickname"]}>
            @{userData?.username ? `${userData.username} ` : "username"}
          </div>
        </div>
      </div>
      <div className={style["shadow"]}></div>
      <div className={style["container-wrapper"]}>
        <div className={style["section-list"]}>{setSection()}</div>
      </div>
    </div>
  );
};

function vibrateDevice() {
  if ("vibrate" in navigator) {
    navigator.vibrate(200); // Вибрация на 200 миллисекунд
  } else {
    console.log("Вибрация не поддерживается в вашем браузере или приложении.");
  }
}

export default Profile;
